<template>
	<div v-if="loading" class="fixed inset-0 z-50 flex items-center justify-center" style="pointer-events: all">
		<div class="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>
		<div class="relative z-10 flex flex-col items-center justify-center p-6 text-white">
			<Spinner small :color="spinnerColor" :class="spinnerSize" />
			<span v-if="message" :class="[messageSize, 'font-medium mt-2']">{{ message }}</span>
		</div>
	</div>
</template>

<script>
import Spinner from './spinner.vue'

export default {
	name: 'LoadingOverlay',
	components: {
		Spinner,
	},
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
		message: {
			type: String,
			default: '',
		},
		messageSize: {
			type: String,
			default: 'text-base',
		},
		spinnerColor: {
			type: String,
			default: 'border-t-white',
		},
		spinnerSize: {
			type: String,
			default: 'h-8 w-8',
		},
	},
	data() {
		return {}
	},
	watch: {
		loading(newVal) {
			this.$nextTick(() => {
				if (newVal) {
					this.preventScroll()
				} else {
					this.allowScroll()
				}
			})
		}
	},
	mounted() {
		if (this.loading) {
			this.$nextTick(() => {
				this.preventScroll()
			})
		}
	},
	beforeUnmount() {
		this.allowScroll()
	},
	methods: {
		preventScroll() {
			document.body.style.overflow = 'hidden'
			document.body.style.height = '100%'
		},
		allowScroll() {
			document.body.style.overflow = ''
			document.body.style.height = ''
		}
	},
}
</script>
